/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useState } from "react";
import MarkdownEntry from "../datatypeComponents/MarkdownEntry";
import StringEntry from "../datatypeComponents/StringEntry";
import CodeableConceptEntry from "../datatypeComponents/CodeableConceptEntry";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import { useDispatch, useSelector } from "react-redux";
import { selectAllResourceChanges } from "../slices/resourceChangeReport/resourceChangeReportSlice";
import { resourceUpdated, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import updateChangeReport from "../slices/resourceChangeReport/updateChangeReport";
import SEVCO, { studyDesignCodeableConceptSet } from "../dictionaries/SEVCO";

const researchStudyDotPhaseValueSet = [
    { system: "http://hl7.org/fhir/research-study-phase", code: "n-a", display: "N/A" },
    { system: "http://hl7.org/fhir/research-study-phase", code: "early-phase-1", display: "Early Phase 1" },
    { system: "http://hl7.org/fhir/research-study-phase", code: "phase-1", display: "Phase 1" },
    { system: "http://hl7.org/fhir/research-study-phase", code: "phase-1-phase-2", display: "Phase 1/Phase 2" },
    { system: "http://hl7.org/fhir/research-study-phase", code: "phase-2", display: "Phase 2" },
    { system: "http://hl7.org/fhir/research-study-phase", code: "phase-2-phase-3", display: "Phase 2/Phase 3" },
    { system: "http://hl7.org/fhir/research-study-phase", code: "phase-3", display: "Phase 3" },
    { system: "http://hl7.org/fhir/research-study-phase", code: "phase-4", display: "Phase 4" }
];

const ResearchStudyResourceEdit = memo(({ foi }) => {

    const dispatch = useDispatch();
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let initialResourceJson = newResourceDetail.resourceJson;
    let resourceJson = newResourceDetail.revisedResourceJson;

    const [editResourceState, setEditResourceState] = useState({
        title: resourceJson.title,
        name: resourceJson.name,
        descriptionSummary: resourceJson.descriptionSummary,
        description: resourceJson.description,
        phase: resourceJson.phase,
        studyDesign: resourceJson.studyDesign,
        relatesTo: resourceJson.relatesTo,
        note: resourceJson.note
    });

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.title;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = editResourceState.title;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            if (editResourceState.title !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.title)) {
                console.log("resourceUpdate for ResearchStudy.title");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "title",
                    previousInitialValue,
                    editResourceState.title);
            }
        }
    }, [editResourceState.titletitle]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.name;
            previousFinalValue = newResourceDetail.revisedResourceJson.name;
            newResourceDetail.revisedResourceJson.name = editResourceState.name;
            newResourceDetail.displayTitle = editResourceState.title || editResourceState.name;
            if (editResourceState.name !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.name)) {
                console.log("resourceUpdate for ResearchStudy.name");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "string",
                    "name",
                    previousInitialValue,
                    editResourceState.name);
            }
        }
    }, [editResourceState.titlename]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.descriptionSummary;
            previousFinalValue = newResourceDetail.revisedResourceJson.descriptionSummary;
            newResourceDetail.revisedResourceJson.descriptionSummary = editResourceState.descriptionSummary;
            if (editResourceState.descriptionSummary !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.descriptionSummary)) {
                console.log("resourceUpdate for ResearchStudy.descriptionSummary");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "markdown",
                    "descriptionSummary",
                    previousInitialValue,
                    editResourceState.descriptionSummary);
            }
        }
    }, [editResourceState.titledescriptionSummary]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.description;
            previousFinalValue = newResourceDetail.revisedResourceJson.description;
            newResourceDetail.revisedResourceJson.description = editResourceState.description;
            if (editResourceState.description !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.description)) {
                console.log("resourceUpdate for ResearchStudy.description");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "markdown",
                    "description",
                    previousInitialValue,
                    editResourceState.description);
            }
        }
    }, [editResourceState.titledescription]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.phase;
            previousFinalValue = newResourceDetail.revisedResourceJson.phase;
            newResourceDetail.revisedResourceJson.phase = editResourceState.phase;
            if (editResourceState.phase !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.phase)) {
                console.log("resourceUpdate for ResearchStudy.phase");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "CodeableConcept",
                    "phase",
                    previousInitialValue,
                    editResourceState.phase);
            }
        }
    }, [editResourceState.titlephase]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.studyDesign;
            previousFinalValue = newResourceDetail.revisedResourceJson.studyDesign;
            newResourceDetail.revisedResourceJson.studyDesign = editResourceState.studyDesign;
            if (editResourceState.studyDesign !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.studyDesign)) {
                console.log("resourceUpdate for ResearchStudy.studyDesign");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfCodeableConcept",
                    "studyDesign",
                    previousInitialValue,
                    editResourceState.studyDesign);
            }
        }
    }, [editResourceState.titlestudyDesign]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.relatesTo;
            previousFinalValue = newResourceDetail.revisedResourceJson.relatesTo;
            newResourceDetail.revisedResourceJson.relatesTo = editResourceState.relatesTo;
            if (editResourceState.relatesTo !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.relatesTo)) {
                console.log("resourceUpdate for ResearchStudy.relatesTo");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfRelatesTo",
                    "relatesTo",
                    previousInitialValue,
                    editResourceState.relatesTo);
            }
        }
    }, [editResourceState.titlerelatesTo]);

    useEffect(() => {
        if (editResourceState) {
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = initialResourceJson.note;
            previousFinalValue = newResourceDetail.revisedResourceJson.note;
            newResourceDetail.revisedResourceJson.note = editResourceState.note;
            if (editResourceState.note !== undefined &&
                JSON.stringify(previousFinalValue) !== JSON.stringify(editResourceState.note)) {
                console.log("resourceUpdate for ResearchStudy.note");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, foi,
                    "ArrayOfAnnotation",
                    "note",
                    previousInitialValue,
                    editResourceState.note);
            }
        }
    }, [editResourceState.titlenote]);

    return <div>
        {editResourceState && <>
            <StringEntry elementName='title'
                fieldLabel={'Study Title'}
                startingValue={editResourceState.title || ""}
                required={(editResourceState.description || editResourceState.descriptionSummary || editResourceState.phase || editResourceState.studyDesign || editResourceState.relatesTo || editResourceState.note)}
                setResourceState={setEditResourceState} />
            <StringEntry elementName='name' fieldLabel='Study Name (for machine use)'
                startingValue={editResourceState.name || ""} setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='descriptionSummary' fieldLabel={'Brief Study Description'}
                startingValue={editResourceState.descriptionSummary || ""} setResourceState={setEditResourceState} />
            <MarkdownEntry elementName='description' fieldLabel={'Long Study Description'}
                startingValue={editResourceState.description || ""} setResourceState={setEditResourceState} />
            <CodeableConceptEntry elementName='phase' fieldLabel='Phase'
                valueSet={researchStudyDotPhaseValueSet}
                startingValue={editResourceState.phase} setResourceState={setEditResourceState} />
            <ArrayEntry datatype='CodeableConcept'
                elementName='studyDesign' fieldLabel='Study Design'
                valueSet={SEVCO.studyDesign} codeableConceptLevelValueSet={studyDesignCodeableConceptSet}
                startingValue={editResourceState.studyDesign} setResourceState={setEditResourceState} />
            <ArrayEntry datatype='RelatesTo'
                elementName='relatesTo' fieldLabel='Related Item'
                startingValue={editResourceState.relatedArtifact} setResourceState={setEditResourceState} />
            <ArrayEntry datatype='Annotation'
                elementName='note' fieldLabel='Note'
                startingValue={editResourceState.note} setResourceState={setEditResourceState} />
            <br />
        </>}
    </div>
})

export default ResearchStudyResourceEdit;